import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungKiel() {
  return (
    <CityPageTemplate
      city="Kiel"
      slug="kiel"
      intro="In der Landeshauptstadt Kiel direkt an der Ostsee beraten wir Dich digital und ohne Umwege."
      description="Unabhängige & digitale Finanzberatung für Kiel: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
